import { connect } from 'react-redux';
import { USER_ROLE } from 'constants/logic';

import { selectUserInfo } from 'selectors/general';
import {
  selectOwnerAccounts,
  selectManagerAccounts,
  selectFrontDeskAccounts,
  selectStaffAccountsIsLoading,
} from './StaffAccounts.selectors';
import StaffAccounts from './StaffAccounts';

const mapStateToProps = state => {
  const user = selectUserInfo(state);
  const { venuesList: venues, role, ...restUser } = user;
  const formattedUser = { venues, role, ...restUser };
  const owners = selectOwnerAccounts(state);
  const managers = selectManagerAccounts(state);
  const frontDesks = selectFrontDeskAccounts(state);

  const prependCurrentUser = staffAccountsList => [formattedUser, ...staffAccountsList];

  return {
    owners: role === USER_ROLE.OWNER ? prependCurrentUser(owners) : owners,
    managers: role === USER_ROLE.MANAGER ? prependCurrentUser(managers) : managers,
    frontDesks: role === USER_ROLE.FRONT_DESK ? prependCurrentUser(frontDesks) : frontDesks,
    isLoading: selectStaffAccountsIsLoading(state),
  };
};

export default connect(mapStateToProps)(StaffAccounts);
